export default __webpack_public_path__ + "static/nike.url-b69a356d8e44061d1f72666bca55acb6.svg";